<script>
import TaxReturnTableRow from "@/components/accountants/tax_return/table/TaxReturnTableRow.vue";
import TaxReturnTable from "@/components/accountants/tax_return/table/TaxReturnTable.vue";
import TaxReturnTableHeader from "@/components/accountants/tax_return/table/TaxReturnTableHeader.vue";

export default {
  name: "TaxReturnEmployeeSection",
  components: {TaxReturnTableHeader, TaxReturnTable, TaxReturnTableRow},
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <TaxReturnTable>
    <template v-slot:header>
      <TaxReturnTableHeader/>
    </template>

    <template v-slot:body>
      <TaxReturnTableRow :description="$gettext('Loon en salarissen')"
                         :calculated-value="data.calculated.statement_employees_salary"
                         v-model="data.edit.statement_employees_salary"/>

      <TaxReturnTableRow :description="$gettext('Sociale lasten')"
                         :calculated-value="data.calculated.statement_employees_burdens"
                         v-model="data.edit.statement_employees_burdens"/>

       <TaxReturnTableRow :description="$gettext('Pensioenslasten')"
                         :calculated-value="data.calculated.statement_employees_pensions"
                         v-model="data.edit.statement_employees_pensions"/>

      <TaxReturnTableRow :description="$gettext('Overige personeelskosten')"
                         :calculated-value="data.calculated.statement_employees_other"
                         v-model="data.edit.statement_employees_other"/>

      <TaxReturnTableRow :description="$gettext('Ontvangen uitkeringen en subsidies')"
                         :calculated-value="data.calculated.statement_employees_subsidies"
                         v-model="data.edit.statement_employees_subsidies"/>
    </template>
  </TaxReturnTable>
</template>

<style scoped lang="scss">

</style>